import { supabase } from "@/integrations/supabase/client";

interface ActivityPayload {
  action: string;
  details?: string;
  metadata?: Record<string, unknown>;
}

/**
 * Logs a user activity and sends an email notification to the admin.
 * Fire-and-forget — never blocks the user experience.
 */
export const logActivity = (payload: ActivityPayload) => {
  supabase.auth.getSession().then(({ data: { session } }) => {
    const body = {
      ...payload,
      user_id: session?.user?.id ?? null,
      user_email: session?.user?.email ?? null,
      user_name:
        session?.user?.user_metadata?.full_name ??
        session?.user?.email ??
        "Anonymous",
    };

    supabase.functions.invoke("notify-activity", { body }).catch(() => {
      // Silently swallow — activity logging should never block UX
    });
  });
};
